import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { useFetch, useFilter, useLanguage, usePagination } from "hooks";
import {
  Layout,
  SearchForm,
  GridList,
  BookCard,
  SideFilter,
  Skeletons,
} from "components";
import Tabs from "pages/Curriculum/Tabs";

function List() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const navigate = useNavigate();
  const { page, handleSetPage } = usePagination();
  const searchKey = React.useRef("");
  const [booksFilterResponse, booksFilterRequest] = useFetch(
    `getBooksFilters`,
    "POST"
  );
  const filters = useFilter(booksFilterResponse.result.data);
  const [booksResponse, booksRequest] = useFetch(`getBooks`, "POST");

  const handleSearch = (keyword) => {
    searchKey.current = keyword;
    filters.reset();
    handleSetPage(1);
  }; // on search

  const handleGetData = React.useCallback(
    async (keyword) => {
      let filtersToSend = {};
      filters.selectedFilters.forEach((sf1) => {
        filtersToSend[sf1.key] = filters.selectedFilters
          .filter((sf2) => sf1.key === sf2.key)
          .map((sf2) => sf2.values)[0];
      });
      booksRequest(
        {
          filters: { ...filtersToSend },
          search_key: searchKey.current || keyword,
          section_type: 1,
        },
        `?page=${page}`
      );
      booksFilterRequest({
        page_type: "books",
        filters: { ...filtersToSend },
        parent_ids: [],
        section_ids: [1],
        refresh_total: "1",
      });
    },
    [booksRequest, filters.selectedFilters, page, searchKey]
  );// get data from the API

  React.useEffect(() => {
    handleGetData();
  }, [filters.selectedFilters, handleGetData, page]); // call data getter function on page, selectedFilters, or searchKey change 

  return (
    <Layout>
      <div id="books_page" className="page_container pt-5">
        <section className="mb-3">
          <Container>
            <Row>
              <Col
                xl={6}
                lg={6}
                md={12}
                sm={12}
                xs={12}
                className="mb-lg-0 pb-lg-0 mb-4 "
              >
                <Row>
                  {/* section Button */}
                  <Col xs={12}>
                    <NavLink to="/contact" className="btn btn-outline-primary">
                      {language.askTheLibrarian}
                    </NavLink>
                  </Col>
                </Row>
              </Col>

              <Col
                xl={6}
                lg={6}
                md={12}
                sm={12}
                xs={12}
                className="align-items-center d-flex flex-column justify-content-center"
              >
                <div className="col-10">
                  <SearchForm onSubmit={(keyword) => handleSearch(keyword)} />
                </div>
              </Col>

              <Col xs={12} className="my-4">
                <Row>
                  <Col xs={12} lg={12}>
                    <Tabs
                      tabs={[
                        {
                          id: 1,
                          name: language.books,
                        },
                        {
                          id: 2,
                          name: language.curriculumSection,
                        },
                      ]}
                      currentTab={1}
                      setCurrentTab={() => {
                        navigate("/curriculum");
                      }}
                      alternate
                    />
                    {/* component that take tabs as a array and show it and handel tabs active */}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="mb-3">
          <Container>
            <Row>
              <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                {!booksFilterResponse.loading &&
                  booksFilterResponse.result.data && (
                    <SideFilter
                      title={language.booksFilter}
                      filters={filters}
                      type="checkbox"
                    />
                    // component that displays filters and handel its actions by using useFilter
                  )}
              </Col>

              <Col xl={9} lg={9} md={12} sm={12} xs={12} className="mx-auto">
                {!booksResponse.loading && booksResponse.result.data ? (
                  <GridList
                    perRow={3}
                    itemsCount={booksResponse.result.meta.total}
                    perPage={booksResponse.result.meta.per_page}
                    as={BookCard}
                    items={booksResponse.result.data}
                  /> // book results card show
                ) : (
                  <Skeletons.CardsSkeleton count={12} perRow={3} />
                )}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
}

export default List;
